import { render, staticRenderFns } from "./deleteUser.vue?vue&type=template&id=44389a63"
import script from "./deleteUser.vue?vue&type=script&lang=js"
export * from "./deleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports